import React from 'react';
import './index.scss';
import GraphLoader from '../../../../../../../../Components/ContentLoaders/GraphLoader';
import { EmptyState } from '../../../../../../../../Packages/EmptyState';

const RatersResponseTable = (props) => {
  let rows = props.fetchTotalFeedbackProvidersApi.data != null ? props.fetchTotalFeedbackProvidersApi.data : []
  return (
    <div className='cardwrapper'>
      <h3>Total Feedback Providers</h3>
      <p className='description-container'>These are the number of feedback providers within each group.</p>
      {props.fetchTotalFeedbackProvidersApi.isProcessing ? <GraphLoader width={800} height={200} /> :
        (props.fetchTotalFeedbackProvidersApi.error && props.fetchTotalFeedbackProvidersApi.data === null) || (props.fetchTotalFeedbackProvidersApi.data != null && props.fetchTotalFeedbackProvidersApi.data.length === 0) ?
          < EmptyState emptyStateMessage="No data found" /> :

          <div className="dynamic-table-wrapper">
        <table className="dynamic-table">
          <thead>
            <tr>
              {rows.map((col, idx) => (
                <th
                  key={col.key}
                  className={idx === rows.length - 1 ? 'last-header' : ''}
                >
                  {col.type.charAt(0).toUpperCase() + col.type.slice(1)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {rows.map((col, idx) => (
                <td
                  key={col.key}
                  className={idx === rows.length - 1 ? 'last-cell' : ''}
                >
                  {col.value}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>}

    </div>
  );
};

export default RatersResponseTable;
